import { render, staticRenderFns } from "./WhatsappGroupsImport.vue?vue&type=template&id=3ba06207"
import script from "./WhatsappGroupsImport.vue?vue&type=script&lang=js"
export * from "./WhatsappGroupsImport.vue?vue&type=script&lang=js"
import style0 from "./WhatsappGroupsImport.vue?vue&type=style&index=0&id=3ba06207&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports